export const areStringArraysEqual = (arr1: string[], arr2: string[]) => {
  const set1 = new Set(arr1)
  const set2 = new Set(arr2)
  return set1.size === set2.size && [...set1].every((value) => set2.has(value))
}
